import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getCurrentUser } from '@api/users';

import { USER_DETAILS } from '@constants/queryKeys';

export const useQueryUserDetails = () => {
	const {
		user,
		activeOrganisation,
		accessPermission: { platformOwnerAdministrator },
	} = useAppSelector(auth);

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [USER_DETAILS],
		queryFn: getCurrentUser,
		enabled: [!!user?.id, platformOwnerAdministrator || !!activeOrganisation],
		refetchOnWindowFocus: false,
	});

	return {
		organisationName: data?.organization?.name || '',
		organisationId: data?.organization?.id || '',
		organisationTypes: data?.organization?.types || [],
		user: data,
		isLoadingCurrentUser: (isLoading && !!data) || isFetching,
	};
};
